import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

type BooleanSelectVariant = "risk" | "neutral";

export type BooleanSelectProps = {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
  variant?: BooleanSelectVariant;
};

export function getSelectTriggerClassName(
  displayValue: string | null,
  variant: BooleanSelectVariant = "risk"
): string {
  const base = "h-9 text-sm font-semibold border-2";

  if (!displayValue) return `${base} border-ds-border-200`;

  if (variant === "neutral") {
    if (displayValue === "Da") {
      return `${base} border-ds-blue-300 bg-ds-blue-50 text-ds-blue-700`;
    }
    if (displayValue === "Nu") {
      return `${base} border-ds-border-300 bg-ds-surface-50 text-ds-text-600`;
    }
    return `${base} border-ds-border-200`;
  }

  if (displayValue === "Da" || displayValue === "Ridicat") {
    return `${base} border-ds-red-400 bg-ds-red-50 text-ds-red-700`;
  }
  if (displayValue === "Mediu") {
    return `${base} border-ds-orange-400 bg-ds-orange-50 text-ds-orange-700`;
  }
  if (displayValue === "Nu" || displayValue === "Scăzut") {
    return `${base} border-ds-yellow-400 bg-ds-yellow-50 text-ds-yellow-700`;
  }
  return `${base} border-ds-border-200`;
}

function BooleanSelect({
  value,
  onChange,
  variant = "risk",
}: BooleanSelectProps) {
  const displayValue = value === true ? "DA" : value === false ? "NU" : "";

  return (
    <Select
      value={displayValue}
      onValueChange={(val) => {
        if (val === "DA") onChange(true);
        else if (val === "NU") onChange(false);
        else onChange(null);
      }}
    >
      <SelectTrigger
        className={getSelectTriggerClassName(
          value === true ? "Da" : value === false ? "Nu" : null,
          variant
        )}
      >
        <SelectValue placeholder="Selectează..." />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="DA">Da</SelectItem>
        <SelectItem value="NU">Nu</SelectItem>
      </SelectContent>
    </Select>
  );
}

export default BooleanSelect;
